import { ContentThumbnail, ContentTitle, Grid } from "@/components";
import { useFullItems, useNavigateToItem } from "@/hooks";
import { FullItems, ItemType } from "@/api";
import { cn, getContentThumbnailUrl, getContentTitle } from "@/utils";

interface PlaylistGridProps {
  items: { ChildId: string; Type: ItemType }[];
  fullItems: FullItems;
}

export const PlaylistGrid = ({ items, fullItems }: PlaylistGridProps) => {
  const { navigateToItem } = useNavigateToItem();
  const { getFullItem } = useFullItems(fullItems);

  return (
    <Grid>
      {items.map((item) => {
        const fullItem = getFullItem(item);
        if (!fullItem) {
          return null;
        }
        const thumbnail = getContentThumbnailUrl(fullItem);
        return (
          <div key={`favourite-${item.ChildId}`}>
            <ContentThumbnail
              className={cn(["w-full cursor-pointer rounded-[8px]"])}
              contentItem={fullItem}
              thumbnail={thumbnail}
              onClick={() => navigateToItem({ item })}
            />
            <ContentTitle title={getContentTitle(fullItem)} />
          </div>
        );
      })}
    </Grid>
  );
};
